// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-toggle[data-v-3f876488]{cursor:pointer;position:relative;z-index:100;display:flex;align-items:center;gap:5px}.list-toggle--active[data-v-3f876488]{color:var(--jw-yellow-500)}", ""]);
// Exports
module.exports = exports;
